module.exports = __webpack_public_path__ + "static/media/08.eff992c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/japan-three/08.jpg
// module id = 450
// module chunks = 0